import React from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import SafeIcon from '../../common/SafeIcon'
import * as FiIcons from 'react-icons/fi'

const { FiHome, FiPlus, FiEdit3, FiSettings, FiUser, FiCreditCard, FiLogOut } = FiIcons

const Sidebar = () => {
  const { signOut } = useAuth()
  const navigate = useNavigate()

  const handleSignOut = async () => {
    await signOut()
    navigate('/auth')
  }

  const navItems = [
    { to: '/dashboard', icon: FiHome, label: 'Dashboard' },
    { to: '/create', icon: FiPlus, label: 'Create Deck' },
    { to: '/account', icon: FiUser, label: 'Account' },
    { to: '/plan', icon: FiCreditCard, label: 'Plan' },
  ]

  return (
    <div className="w-64 bg-white border-r border-gray-200 h-screen flex flex-col">
      {/* Logo */}
      <div className="p-6 border-b border-gray-200">
        <div className="flex items-center space-x-3">
          <img 
            src="https://ymwrzyarkxxnsqllnnfu.supabase.co/storage/v1/object/public/assets/nupitch_logo_ol-Centered_001.svg" 
            alt="NuPitch Logo" 
            className="w-10 h-10"
          />
          <span className="text-xl font-bold text-gray-900">NuPitch</span>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4 space-y-2">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${
                isActive
                  ? 'bg-primary-50 text-primary-600 border border-primary-200'
                  : 'text-gray-600 hover:bg-gray-50'
              }`
            }
          >
            <SafeIcon icon={item.icon} className="w-5 h-5" />
            <span className="font-medium">{item.label}</span>
          </NavLink>
        ))}
      </nav>

      {/* Sign Out */}
      <div className="p-4 border-t border-gray-200 space-y-3">
        <button
          onClick={handleSignOut}
          className="flex items-center space-x-3 px-4 py-3 rounded-lg text-gray-600 hover:bg-gray-50 w-full transition-colors"
        >
          <SafeIcon icon={FiLogOut} className="w-5 h-5" />
          <span className="font-medium">Sign Out</span>
        </button>
        
        {/* Legal Links */}
        <div className="flex flex-col space-y-2 px-4">
          <a
            href="/#/terms"
            className="text-sm text-gray-500 hover:text-gray-700 transition-colors"
          >
            Terms of Service
          </a>
          <a
            href="/#/privacy"
            className="text-sm text-gray-500 hover:text-gray-700 transition-colors"
          >
            Privacy Policy
          </a>
        </div>
      </div>
    </div>
  )
}

export default Sidebar